import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App.jsx";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { persistor, store } from "./redux/store.js";
import axios from "axios";
import envConfig from "@/config/envConfig";
import { FlareErrorBoundary } from "@flareapp/react";
import { flare } from "@flareapp/js";

axios.defaults.baseURL = envConfig.API_URL;
axios.defaults.withCredentials = true;

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === "production") {
  flare.light(import.meta.env.VITE_FLARE_KEY);
}

createRoot(document.getElementById("root")).render(
  <>
    <FlareErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </FlareErrorBoundary>
  </>,
);
